import { render } from "./LayoutsAuthSidebar.vue?vue&type=template&id=61e3591a&scoped=true&ts=true"
import script from "./LayoutsAuthSidebar.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthSidebar.vue?vue&type=script&lang=ts"

import "./LayoutsAuthSidebar.vue?vue&type=style&index=0&id=61e3591a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e3591a"]])

export default __exports__